export class FormValidatorListener {
    public static bindFormSubmit(form: HTMLFormElement, onSubmit: (event: Event) => void): void {
        form.addEventListener("submit", onSubmit);
    }

    public static bindFieldBlur(field: HTMLElement, onBlur: () => void): void {
        field.addEventListener("blur", onBlur);
    }

    public static bindFieldInput(field: HTMLElement, onInput: () => void): void {
        field.addEventListener("input", onInput);
    }
}
